// extracted by css-extract-rspack-plugin
export default {"AttachmentSwitchBody":"zag0V","AttachmentSwitchInput":"Gj8gi"};